// The engineer PWA's one card, one pill and one button language (visual polish pass, 8 October
// 2026). Class strings only: no state, no logic. Home, My Jobs and the offline list read the same
// card and pill so a job looks the same wherever the engineer meets it. Every colour is a theme
// token, so light and dark follow the shell exactly as before; no left stripe anywhere (the
// NO LEFT-STRIPE RULE), hover and press are a background wash.

/** The one card: rounded, hairline border, a soft shadow that themes with --ele-shadow. */
export const ENG_CARD = "rounded-xl border border-ele-card-border bg-ele-card shadow-[0_1px_3px_var(--ele-shadow)]";

/** A whole-card link (a job card). 44px minimum, washes on hover and press. */
export const ENG_CARD_LINK = `${ENG_CARD} flex min-h-11 gap-3 p-3.5 transition-colors hover:bg-ele-row-hover active:bg-ele-row-hover`;

/** An overdue card: the same card, its border in the themed danger colour. Inline, because two
 *  border-colour utilities on one element resolve by stylesheet order, not class order. */
export const ENG_CARD_OVERDUE_STYLE = { borderColor: "var(--ele-danger)" } as const;

/** The one status pill. Colour comes from the caller's tint and ink. */
export const ENG_PILL =
  "inline-flex flex-none items-center whitespace-nowrap rounded-full px-2.5 py-1 font-menu text-[11px] font-medium uppercase leading-none tracking-wide";

/** The job type word on a card, quiet so the site name leads. */
export const ENG_TYPE_LABEL = "font-menu text-[11px] uppercase tracking-wide text-ele-muted";

/** The one primary button: solid brand green, dark ink (white on #63C41F fails AA). */
export const ENG_BTN_PRIMARY =
  "flex min-h-12 w-full items-center justify-center rounded-xl bg-ele-green px-4 font-heading text-lg tracking-wide text-ele-bg shadow-[0_1px_3px_var(--ele-shadow)] transition hover:brightness-110 active:brightness-95 disabled:opacity-50";

/** The one secondary button: outlined, no fill. */
export const ENG_BTN_SECONDARY =
  "flex min-h-11 items-center justify-center rounded-xl border border-ele-hairline-strong bg-transparent px-4 font-menu text-sm tracking-wide text-ele-strong transition hover:bg-ele-row-hover";

/** Section heading on a list screen. */
export const ENG_SECTION_HEADING = "font-heading text-lg tracking-wide text-ele-strong";

/** The danger ink and tint, themed (#c0392b on light, #FF5A5A on dark). */
export const DANGER_INK = "var(--ele-danger)";
export const DANGER_TINT = "var(--ele-pill-tint-red)";

// Dates on an engineer's lists always carry the year ("Wed 8 Oct 2026"), so two visits to one site
// months apart are told apart at a glance.
export function dayWithYear(d: Date): string {
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}
export function dayTimeWithYear(d: Date): string {
  return `${dayWithYear(d)}, ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}
